export default __webpack_public_path__ + "static/media/caloTokenLeft.0362a202.png";